import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { Button } from './ui/button';

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const location = useLocation();

  const navLinks = [
    { path: '/', label: 'Home' },
    { path: '/about', label: 'About' },
    { path: '/products', label: 'Products' },
    { path: '/services', label: 'Services' },
    { path: '/contact', label: 'Contact' }
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <nav className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-sm border-b border-orange-500/20">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center space-x-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_0417eede-7f78-4297-8d8e-61eaa65cf77a/artifacts/912rynrx_SIX_0781F903-DCAC-4428-8B33-C4C3EA246FFA.png" 
              alt="SubZero Coolers" 
              className="h-12 w-auto"
            />
          </Link>

          {/* Desktop Navigation */}
          <div className="hidden md:flex items-center space-x-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`text-sm font-medium transition-colors duration-300 ${
                  isActive(link.path)
                    ? 'text-orange-500'
                    : 'text-gray-300 hover:text-orange-400'
                }`}
              >
                {link.label}
              </Link>
            ))}
          </div>

          {/* Emergency Contact */}
          <div className="hidden lg:flex items-center space-x-4">
            <div className="text-right">
              <p className="text-xs text-gray-400">Office Hours 9AM-5PM</p>
              <a href="tel:772-362-9384" className="text-sm font-bold text-orange-500 hover:text-orange-400 transition-colors">
                772-362-9384
              </a>
            </div>
            <Button asChild className="bg-orange-500 hover:bg-orange-600 text-black font-semibold">
              <Link to="/contact">Get Quote</Link>
            </Button>
          </div>

          {/* Mobile Menu Button */}
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="md:hidden text-gray-300 hover:text-orange-500 transition-colors"
          >
            {isOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="md:hidden bg-black/98 border-t border-orange-500/20">
          <div className="px-4 py-6 space-y-4">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setIsOpen(false)}
                className={`block text-base font-medium transition-colors ${
                  isActive(link.path)
                    ? 'text-orange-500'
                    : 'text-gray-300 hover:text-orange-400'
                }`}
              >
                {link.label}
              </Link>
            ))}
            <div className="pt-4 border-t border-gray-800">
              <p className="text-xs text-gray-400 mb-1">Office Hours 9AM-5PM</p>
              <a href="tel:772-362-9384" className="flex items-center space-x-2 text-orange-500 font-bold">
                <Phone size={16} />
                <span>772-362-9384</span>
              </a>
            </div>
            <Button asChild className="w-full bg-orange-500 hover:bg-orange-600 text-black font-semibold">
              <Link to="/contact" onClick={() => setIsOpen(false)}>Get Quote</Link>
            </Button>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
